import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from './core/services/local-storage.service';
import { LocalStorageKeys } from './core/constants/local-storage.constants';
import { AppStateService } from './core/services/app-state.service';
import { UserPreference } from './shared/models/user-preference.model';

@Component({
  selector: 'vota-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'Vota';

  constructor(
    private localStorageService: LocalStorageService,
    private appStateService: AppStateService
  ) {}

  ngOnInit(): void {
    this.getUserPreferences();
    console.info("Version 1.0.44 running...!!");
  }

  private getUserPreferences(): void {
    const userPreference =
      this.localStorageService.getItemWithExpiry<UserPreference | null>(
        LocalStorageKeys.USER_PREFERENCES
      );
    if (userPreference) {
      this.appStateService.setThemeMode(userPreference.darkMode);
    }
  }
}
